module.exports = __webpack_public_path__ + "static/akinsoye-2f863234a0bff6c2f41df7b9ab9d78f2.jpg";